import { Box, Flex, HStack, Heading, Image, Text } from '@chakra-ui/react';
import bgBrandModelImage from 'assets/background/auto_brand.png';
import { BRAND_REDIRECT_LINK } from 'constants/links';
import { useTranslation } from 'react-i18next';

interface BrandKitRedirectButtonProps {
  title: string;
  text: string;
  hasBrandEditPermission: boolean;
}

export const BrandKitRedirectButton = ({ title, text, hasBrandEditPermission }: BrandKitRedirectButtonProps) => {
  const { t } = useTranslation('auto_brand', { useSuspense: false, keyPrefix: 'modals.autoBrand' });
  return (
    <>
      {hasBrandEditPermission && (
        <Flex mx={1}>
          <Box
            as='a'
            href={BRAND_REDIRECT_LINK}
            target='_blank'
            rel='noopener noreferrer'
            p='4'
            flexDir='column'
            justifyContent='space-around'
            _hover={{ backgroundColor: 'var(--vg-colors-a11yMenu-hover)' }}
            data-testid='brand-card'
            boxShadow='sm'
            background='violet.50'
            w='full'
            borderRadius='sm'
          >
            <HStack gap='2'>
              <Image src={bgBrandModelImage} w='65px' minH='54px' role='presentation' alt='' />
              <Flex flexDirection='column' textAlign='left'>
                <Heading fontSize={'sm'} marginBottom='2'>
                  {title}
                </Heading>
                <Text fontSize={'xs'}>{text}</Text>
              </Flex>
            </HStack>
          </Box>
        </Flex>
      )}
      {!hasBrandEditPermission && (
        <Text fontSize='sm' data-testid='ask-admin-brand-text' fontWeight='semibold' textAlign='center' marginTop={4}>
          {t('askYourAdmin')}
        </Text>
      )}
    </>
  );
};
